import { render, staticRenderFns } from "./UbahKategori.vue?vue&type=template&id=1ed47f9f&scoped=true"
import script from "./UbahKategori.vue?vue&type=script&lang=js"
export * from "./UbahKategori.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed47f9f",
  null
  
)

export default component.exports